import constants from "../constants";

const {
  UPDATE_MAIN_USER,
  REMOVE_MAIN_USER,
  OPEN_CLIENT_RESERVATION_SELECTOR,
  CLOSE_CLIENT_RESERVATION_SELECTOR,
} = constants;

const initialState = {
  communication: false,
  alerts: false,
  customApp: {
    customLang: {
      en: {
        titleWelcome: "Hello! We hope you enjoy your stay with us",
        titleRooms: "Your apartment",
      },
      es: {
        titleWelcome: "¡Hola! Esperamos que disfrutes de tu estancia con nosotros",
        titleRooms: "Tu apartamento",
      },
      fr: {
        titleWelcome: "Bonjour ! Nous espérons que vous passerez un agréable séjour parmi nous.",
        titleRooms: "Votre appartement",
      },
    },
    menuConfig: {
      apartments: { defaultLabel: "apartments", label: null, visible: true },
      occupancy: { defaultLabel: "occupancy", label: null, visible: true },
      amenities: { defaultLabel: "amenities", label: null, visible: true },
      services: { defaultLabel: "services", label: null, visible: true },
      onnaDevices: { defaultLabel: "onnaDevices", label: null, visible: true },
      cloudApis: { defaultLabel: "cloudApis", label: null, visible: true },
      analytics: { defaultLabel: "analytics", label: null, visible: true },
      settings: { defaultLabel: "settings", label: null, visible: true },
      email: { defaultLabel: "customEmailToClients", label: null, visible: true },
      customApp: { defaultLabel: "customApp", label: null, visible: true },
      certifications: { defaultLabel: "certifications", label: null, visible: true },
      notifications: { defaultLabel: "notificationsToClients", label: null, visible: true },
    },

    useCustomWelcomeBackgroundColor: false,
    customWelcomeBackgroundColor: "",
    useCustomIconColor: false,
    customIconColor: "",
    useCustomAppBackgroundColor: false,
    customAppBackgroundColor: "",
    useCustomCardColor: false,
    customCardColor: "",
  },
  isValidated: false,
  isMainUser: false,
  isClient: false,
  isProjectManager: false,
  clientReservationSelection: {
    isOpen: false,
    reservations: [],
    pendingAuth: null,
  },
};

export default (state = initialState, action) => {
  if (!action) return state;
  const { type } = action;
  switch (type) {
    case UPDATE_MAIN_USER:
      return {
        ...state,
        ...action?.data,
        customApp: {
          ...initialState.customApp,
          ...action?.data?.customApp,
          menuConfig: {
            ...initialState.customApp?.menuConfig,
            ...action?.data?.customApp?.menuConfig,
          },
        },
      };
    case OPEN_CLIENT_RESERVATION_SELECTOR: {
      return {
        ...state,
        clientReservationSelection: {
          isOpen: true,
          reservations: action?.data?.reservations || [],
          pendingAuth: action?.data?.pendingAuth || null,
        },
      };
    }
    case CLOSE_CLIENT_RESERVATION_SELECTOR:
      return {
        ...state,
        clientReservationSelection: {
          isOpen: false,
          reservations: [],
          pendingAuth: null,
        },
      };
    case REMOVE_MAIN_USER:
      return initialState;
    default:
      return state;
  }
};
